export enum TimeAssignedEnum {
  _45_minutes = 45,
  _60_minutes = 60,
  _75_minutes = 75,
  _90_minutes = 90,
}
